// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useState, useCallback } from 'react';
import { useScrollable } from '../Scroll/usePopoverScrollable';
import { useDropdownPosition } from '../Popover/useDropdownPosition';
export function useComboboxDropdown({ comboboxRef, comboboxPopoverRef, autoFocus = false, onClose }) {
    const [isOpened, setIsOpened] = useState(autoFocus);
    const toggleOpen = useCallback(() => {
        setIsOpened((prev) => {
            const newIsOpened = !prev;
            if (!newIsOpened) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
            return newIsOpened;
        });
    }, [onClose]);
    const { position: dropdownPosition, minWidth: dropdownMinWidth } = useDropdownPosition({
        anchorRef: comboboxRef,
        dropdownRef: comboboxPopoverRef,
        isActive: isOpened
    });
    useScrollable(comboboxPopoverRef, isOpened, 'y');
    return {
        isOpened,
        dropdownPosition,
        dropdownMinWidth,
        generateKey,
        toggleOpen,
        setIsOpened
    };
}
function generateKey(item, index) {
    if (item.id !== undefined) {
        return item.id;
    }
    if (typeof item.value !== 'object') {
        return String(item.value);
    }
    return index;
}
